import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Widget } from '~/components/MyWorkspace/Widget';
import { useApprovalWidgetData } from '~/scenes/MyWorkspace/components/Widgets/components/ApprovalWidget/useApprovalWidgetData';

import { WidgetProps } from '../../data/widgets';

import { ApprovalWidgetContent } from './components/ApprovalWidgetContent';
import { useSxStyles } from './useStyles';

export interface ApprovalWidgetProps extends WidgetProps {}

export const ApprovalWidget: FC<ApprovalWidgetProps> = ({ title, config }) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const approvalWidgetData = useApprovalWidgetData(config);

  return (
    <Widget
      title={title || t('approvalWidget')}
      content={<ApprovalWidgetContent {...approvalWidgetData} />}
      customSxStyles={{ actions: sxStyles.widgetActions }}
      dataCy="approval-widget"
    />
  );
};
